export default "__VITE_PUBLIC_ASSET__fc00655b__"